/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankDefaults200,
  GetApiV1BankDefaults401,
  GetApiV1BankDefaults500,
  GetApiV1BankDefaultsQueryResponse,
} from "../../types/bankRegistroController/GetApiV1BankDefaults.ts";
import { bankViewModelSchema } from "../bankViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankDefaults200Schema = z.lazy(
  () => bankViewModelSchema,
) as unknown as ToZod<GetApiV1BankDefaults200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankDefaults401Schema =
  z.any() as unknown as ToZod<GetApiV1BankDefaults401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankDefaults500Schema =
  z.any() as unknown as ToZod<GetApiV1BankDefaults500>;

export const getApiV1BankDefaultsQueryResponseSchema = z.lazy(
  () => getApiV1BankDefaults200Schema,
) as unknown as ToZod<GetApiV1BankDefaultsQueryResponse>;
